import React from 'react';
import {SelectPicker} from "rsuite";
import {Controller} from 'react-hook-form';
import "../../../assets/css/inputs/rsuite-select-picker.css"


export default function ({
                           label,
                           name,
                           control,
                           errorMessage,
                           options = [],
                           placeholder = 'აირჩიეთ',
                           className = '',
                           inputClassName = '',
                           optionLabel = "name",
                           optionValue = "id",
                           defaultValue = "",
                           required = false,
                           clearable = true,
                           size = 'sm'
                         }) {

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({field: {onChange, value}}) => (
          <div className={`fv-row mb-10${inputClassName ? " " + inputClassName : ""}`}>
            <label className="form-label fs-6 fw-bolder color-dark-grey">
              {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
            </label>
            <SelectPicker
              appearance="default"
              size={size}
              className={`selectOption ` + className}
              placeholder={placeholder}
              onChange={(selected) => onChange(selected)}
              data={options}
              labelKey={optionLabel}
              valueKey={optionValue}
              defaultValue={defaultValue}
              cleanable={clearable}
              virtualized
            />

            {errorMessage && (
              <div className="fv-plugins-message-container invalid-feedback">
                <div>{errorMessage}</div>
              </div>
            )}
          </div>
        )}
      />
    </>

  )
}